import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2, Lock } from "lucide-react";
import { http } from "@/lib/api";
import { EscapadeHero, EscapadeOverview } from "@/components/EscapadeOverview";
import { PremiumLock } from "@/components/PremiumLock";

const LockedPreview = ({ duration }) => (
  <div data-testid="itinerary-locked-preview" className="relative rounded-2xl bg-white border border-gray-200 p-6 overflow-hidden">
    <p className="font-mono text-[11px] uppercase tracking-widest text-gray-500">Itinéraire détaillé</p>
    <div className="mt-4 space-y-4 blur-[5px] select-none" aria-hidden>
      {Array.from({ length: Math.min(duration, 2) * 3 }).map((_, i) => (
        <div key={i} className="flex gap-4"><span className="font-mono text-sm text-amber-600">{String(9 + i * 2).padStart(2, "0")}:00</span><div className="flex-1 h-10 rounded bg-gray-100" /></div>
      ))}
    </div>
    <div className="absolute inset-0 flex items-center justify-center"><span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0B131E] text-white text-sm"><Lock className="w-4 h-4" />Contenu Premium</span></div>
  </div>
);

export default function EscapadeDetail() {
  const { id } = useParams();
  const [e, setE] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => { http.get(`/escapades/${id}`).then((r) => setE(r.data)).catch(() => setError(true)); }, [id]);

  if (error) return <div data-testid="detail-error" className="py-24 text-center text-gray-600">Escapade introuvable. <Link to="/" className="text-amber-700 underline">Accueil</Link></div>;
  if (!e) return <div className="py-32 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-amber-600" /></div>;

  return (
    <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-10">
      <Link to={`/resultats/${e.search_id}`} data-testid="detail-back-link" className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-amber-700 transition-colors mb-6">
        <ArrowLeft className="w-4 h-4" /> Retour aux 3 escapades
      </Link>
      <EscapadeHero e={e} />
      <div className="mt-10 grid lg:grid-cols-[1.6fr_1fr] gap-8 items-start">
        <div className="space-y-6"><EscapadeOverview e={e} /><LockedPreview duration={e.duration} /></div>
        <div className="lg:sticky lg:top-24"><PremiumLock escapadeId={e.id} duration={e.duration} /></div>
      </div>
    </div>
  );
}
